import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export const useFleetData = (table, vehicleId = null) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    setLoading(true);
    let query = supabase.from(table).select('*').order('created_at', { ascending: false });
    if (vehicleId) query = query.eq('vehicle_id', vehicleId);
    const { data: rows } = await query;
    setData(rows || []);
    setLoading(false);
  }, [table, vehicleId]);

  useEffect(() => { fetch(); }, [fetch]);

  const create = async (values) => {
    const { error } = await supabase.from(table).insert(values);
    if (error) throw error;
    await fetch();
  };

  const update = async (id, values) => {
    const { error } = await supabase.from(table).update({ ...values, updated_at: new Date().toISOString() }).eq('id', id);
    if (error) throw error;
    await fetch();
  };

  const remove = async (id) => {
    const { error } = await supabase.from(table).delete().eq('id', id);
    if (error) throw error;
    await fetch();
  };

  return { data, loading, refetch: fetch, create, update, remove };
};
